<template>
  <div class="mx-md-12 px-sm-12 align--center">
    <p class="display-1 primary--text text-center">Zivildienst im Altenheim</p>

    <p>
      Der Zivildienst bietet vor allem jungen Menschen die Möglichkeit, Einblicke in Gesundheitsberufe zu gewinnen.
      Viele bleiben anschließend im Gesundheitswesen und machen die Ausbildung zum/zur PflegerIn.
    </p>

    <p class="text-center title primary--text mt-3 mb-1">Hauptaufgaben</p>
    <ul>
      <li>Mithilfe bei der Betreuung pflegebedürftiger Menschen</li>
      <li>Beschäftigung mit den BewohnerInnen</li>
      <li>Hol- und Bringdienste</li>
      <li>Organisation der Textilversorgung</li>
      <li>Unterstützung bei Festen und Veranstaltungen</li>
    </ul>
    <br>

    <p>
    <strong>Du möchtest deinen Freiwilligeneinsatz als Zivildiener bei uns im Alten- und Pflegeheim Frankenburg machen - dann kontaktiere uns!</strong><br>
      Wir beraten dich gerne. Jedes Jahr suchen wir für 1. Jänner, 1. April 1. Juli und 1. Oktober 
      für je 9 Monate einen Zivildiener zur Unterstützung und Mithilfe bei uns im Haus.<br>
      Falls du Interesse hast bewirb dich unter <a href="mailto:office@altenheim-frankenburg.at">office@altenheim-frankenburg.at</a> oder schau einfach persönlich vorbei.
    </p>

    <p>
    Weitere Informationen zu den verfügbaren Startterminen findest du hier:
    <a href="https://zivildienst.gv.at/_zuweisung/" target="blank">https://zivildienst.gv.at/_zuweisung/</a>
    </p>

    <div class="text-center">
      <img
      class="hidden-sm-and-down"
      width="50%"
      :src="require('@/assets/Angebote/Zivildienstplaetze/Spielen.jpg')"
      />

      <img
      class="hidden-md-and-up"
      width="100%"
      :src="require('@/assets/Angebote/Zivildienstplaetze/Spielen.jpg')"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'zivildienstplaetze',

    components: {
      TextBild: () => import('@/components/base/TextBild'),
    }
  }
</script>